// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__AeUGu","head":"Modal_head__teEiv","title":"Modal_title__pENSW","close":"Modal_close__-i6Sd","content":"Modal_content__YKAYL"};